// === Galerie produits (tanjentes.fr) — Snap auto sur l'image la plus proche ===
(function () {
  function initOne(root) {
    if (!root || root.dataset.cpgInitialized === '1') return;

    const viewport = root.querySelector('[data-cpg-viewport]');
    if (!viewport) return;

    const slides = Array.from(viewport.querySelectorAll('.cpg__slide'));
    const dots   = Array.from(root.querySelectorAll('.cpg__dot'));
    const prev   = root.querySelector('.cpg__nav--prev');
    const next   = root.querySelector('.cpg__nav--next');

    const total = slides.length;
    if (!total) return;

    let current = 0;
    let isTouching = false;
    let scrollIdleTimer = null;

    function clamp(val, min, max){ return Math.max(min, Math.min(max, val)); }

    function width() { return viewport.clientWidth || 1; }

    function indexFromScroll() {
      // calcule l'index du slide le plus proche du centre du viewport
      const w = width();
      const center = viewport.scrollLeft + w / 2;
      let nearest = 0;
      let bestDist = Infinity;

      slides.forEach((slide, i) => {
        const slideLeft = i * w;
        const slideCenter = slideLeft + w / 2;
        const dist = Math.abs(center - slideCenter);
        if (dist < bestDist) {
          bestDist = dist;
          nearest = i;
        }
      });

      return clamp(nearest, 0, total - 1);
    }

    function goTo(index, smooth = true) {
      const clamped = clamp(index, 0, total - 1);
      const left = clamped * width();
      viewport.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      current = clamped;
      updateDots();
    }

    function updateDots() {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= total - 1;
    }

    function snapSoon(delay = 120) {
      clearTimeout(scrollIdleTimer);
      scrollIdleTimer = setTimeout(() => {
        const idx = indexFromScroll();
        if (idx !== current) current = idx;
        goTo(current, true);
      }, delay);
    }

    // Boutons & puces
    prev && prev.addEventListener('click', () => goTo(current - 1));
    next && next.addEventListener('click', () => goTo(current + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));

    // Tactile : on laisse le momentum iOS, on re-snap à la fin
    viewport.addEventListener('touchstart', () => {
      isTouching = true;
      clearTimeout(scrollIdleTimer);
    }, { passive: true });

    viewport.addEventListener('touchend', () => {
      isTouching = false;
      // petit délai pour laisser finir le momentum avant snap
      snapSoon(140);
    }, { passive: true });

    // Scroll : débounce + snap
    viewport.addEventListener('scroll', () => {
      if (isTouching) return; // on attend la fin du geste
      snapSoon(140);
    }, { passive: true });

    // Resize / orientation change : recalcule la position
    const onResize = () => {
      // recenter le slide courant sur la nouvelle largeur
      goTo(current, false);
    };
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    // Init visuelle
    updateDots();
    goTo(0, false);

    // Marqueur d'init
    root.dataset.cpgInitialized = '1';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cpg]').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));

  // Fallback si la grille est injectée dynamiquement
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes && m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-cpg]')) initOne(node);
        node.querySelectorAll && node.querySelectorAll('[data-cpg]').forEach(initOne);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();






